import React, { useState, useEffect } from 'react'
import List from '../../components/List'
import Filter from '../../components/Filter'
import { Banner } from '../../components/UpperBanner'
import { Loader } from 'talentneuron---ui-components-library'
import gtm from '../../usagetracker/GTM'
import FeedsApi from '../../httpService/feeds'
import { Consumer, Context } from '../../context'
import ConsentForm from '../../consentform'
import { trackingPendoId } from '../../constants'

function LandingPage (props) {
  let [filteredList, setFilteredList] = useState(null)
  let [fullDataList, setFullDataList] = useState([])
  let [isLoading, setIsLoading] = useState(true)
  let [showConsent, setShowConsent] = useState(false)
  const ctx = React.useContext(Context)

  const startPendoTracking = () => {
    if (window.df &&
      window.df.Config &&
      window.df.Config.trackingHotJarId > 0 && window.df.UserContext.ishotjarenabled &&
      window.df.UserContext.isLatestAgreementAccepted) {
      (function (apiKey) {
        (function (p, e, n, d, o) { var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = o._q || []
          v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w) { (function (m) {
            o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))) } })(v[w]) }
          y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js'
          z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z) })(window, document, 'script', 'pendo')
      })(trackingPendoId)

      setTimeout(function () {
        if (!pendo) {
          return
        }
        pendo.initialize({
          visitor: {
            id: window.df.UserContext.userid,
            role: window.df.UserContext.personaName
          },
          account: {
            id: window.df.UserContext.clientname
          }
        })
      }, 1500)
    }
  }

  const getDataFeed = () => {
    FeedsApi.getFeedsList(ctx.userdetails.userid).then((response) => {
      if (!response.data.errorData) {
        setFullDataList(response.data.data)
        setIsLoading(false)
      }
    }).catch((error) => {
      console.log('error while getting feeds list')
    })
  }

  const addDataFeed = (df) => {
    let ListWithoutElementToAdd = fullDataList.filter(feed => feed.id !== df.id)
    let updatedDataList = [df, ...ListWithoutElementToAdd]
    setFullDataList(updatedDataList)
  }

  const deleteDataFeed = (id) => {
    let updatedDFList = fullDataList.filter(el => el.id !== id)
    setFullDataList(updatedDFList)
  }

  const doFilter = (val) => {
    const tmpList = fullDataList.slice(0)
    const textToLookAt = val.toLowerCase()
    const filteredList = tmpList.filter(el => el.name.toLowerCase().indexOf(textToLookAt) > -1)
    setFilteredList(filteredList)
  }

  useEffect(() => {
    const shouldShowConsent =
    window.df &&
    window.df.UserContext &&
    window.df.UserContext.isLatestAgreementAccepted === null
    setShowConsent(shouldShowConsent)
    if (!shouldShowConsent && window.df?.UserContext?.isLatestAgreementAccepted === true) {
      startPendoTracking()
    }

    setIsLoading(true)
    getDataFeed()
    gtm.init(window.df.UserContext)
    gtm.trackWidgetEvent(gtm.events.DataFeedView,
      {
        category: 'Data Feed',
        label: 'Logged in'
      })
  }, [])

  const currentTableData = filteredList || fullDataList
  let state = {
    ...filteredList,
    ...fullDataList,
    ...isLoading
  }
  return (
        <Consumer>
            {

                (value) => {
                  return (
                        <React.Fragment>
                            <Banner {...value}/>
                             {showConsent && <ConsentForm enableHotJarTracking={startPendoTracking} />}
                            <div className={'main-container'}>
                                {isLoading
                                  ? <Loader/>
                                  : <React.Fragment>
                                    <Filter doFilter={doFilter} {...state} />
                                    <List globalState={value} currentList={currentTableData} {...state} updateFeedStatus={getDataFeed} addDataFeed={addDataFeed} deleteDataFeed={deleteDataFeed}/>
                                </React.Fragment>
                                }
                            </div>
                        </React.Fragment>
                  )
                }
            }
        </Consumer>
  )
}

export default LandingPage
